import { useState, useEffect, useCallback } from 'react';
import API from '../common/api.js';

const useStatistics = () => {
    const [statistics, setStatistics] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);
    const [initialized, setInitialized] = useState(false);

    const loadData = useCallback(async () => {
        setLoading(true);
        setErrorMessage(null);

        const response = await API.getStatistics();

        if (response) {
            setStatistics(response);
            setInitialized(true);
        } else {
            setErrorMessage(
                'Failed to load the statistics. Please try again or report this problem, if it persists.'
            );
        }

        setLoading(false);
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);

    return {
        statistics,
        loading,
        errorMessage,
        initialized,
        reload: loadData,
    };
};

export default useStatistics;
